<template>
  <div class="flex">
    <VueDatePicker :value="date"
                   type="month"
                   :locale="{lang:$i18n.locale}"
                   :max-date="maxDate"
                   @input="$emit('change',$event)"
                   color="#486680">
      <template #activator="{ date }">
        <div class="relative w-full">
          <BaseInput class="w-full cursor-pointer"
                     :label="label || $t('currentPeriodLabel')"
                     readonly
                     v-model="date">
          </BaseInput>
          <IconCalendar class="text-border-hover absolute right-4 top-0 bottom-0 m-auto"/>
        </div>
      </template>
    </VueDatePicker>
    <BaseButton @click="changeMonth('sub')"
                class="ml-8 w-16 h-16 flex items-center justify-center text-icon"
                theme="default">
      <font-awesome-icon icon="chevron-left"/>
    </BaseButton>
    <BaseButton @click="changeMonth('add')"
                theme="default"
                class="ml-4 w-16 h-16 flex items-center justify-center text-icon"
                :disabled="button_next_disabled">
      <font-awesome-icon icon="chevron-right"/>
    </BaseButton>
  </div>
</template>

<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import BaseButton from "@/components/UI/BaseButton";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import IconCalendar from "@/components/icons/IconCalendar";

export default {
  name: "MonthPicker",
  components: {IconCalendar, BaseInput, VueDatePicker, BaseButton},
  props: {
    maxDate: {
      type: String
    },
    date: {
      type: String,
      required: true
    },
    label: {
      type: String
    }
  },
  computed: {
    button_next_disabled() {
      return this.date === this.maxDate;
    }
  },
  methods: {
    changeMonth(arg) {
      let month = this.$moment(this.date);
      if (arg === 'sub') {
        month = month.subtract(1, 'months').format('YYYY-MM');
      } else if (arg === 'add') {
        month = month.add(1, 'months').format('YYYY-MM');
      }
      this.$emit('change', month);
    },
  },
  i18n: {
    messages: {
      en: {
        currentPeriodLabel: 'Current period'
      },
      ru: {
        currentPeriodLabel: 'Текущий период'
      }
    }
  }
}
</script>